import { useMutation } from "@apollo/client";
import { CircularProgress, FormControl, Select, InputLabel, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect } from "react";
import { UPDATE_LOCATION } from "../../../../graphql/mutations";

export default function EditDialog({ open, handleClose, onEdit, data, statesLocal }) {

    // Setting mutation
    const [updateLocation, { loading }] = useMutation(UPDATE_LOCATION);

    // Setting Formik
    const { handleSubmit, handleChange, setFieldValue, values, errors, resetForm } = useFormik({
        initialValues: { name: "", state: "", is_city: true },
        onSubmit: (values) => {

            // Chamando a mutation de edição
            updateLocation({
                variables: {
                    id: values.id,
                    name: values.name,
                    state: values.state,
                    is_city: values.is_city,
                }
            }).then(() => {
                onEdit();
            })

        }
    });
    
    useEffect(function () {
        if (data) {
            resetForm();
            setFieldValue('id', data.id);
            setFieldValue('name', data.name);
            setFieldValue('state', data.state);
        }
    }, [data]);
    
    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll="paper"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle id="scroll-dialog-title">Editar Localização</DialogTitle>

                <DialogContent style={{padding: 16}}>

                    <TextField
                        variant="outlined"
                        margin="normal"
                        onChange={handleChange}
                        value={values.name}
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoFocus
                        error={errors.name && true}
                        helperText={errors.name}
                    />
                    <FormControl variant="outlined" fullWidth style={{margin: '8px 0 16px 0'}}>
                        <InputLabel htmlFor="outlined-age-native-simple">Estado</InputLabel>
                        <Select
                            native
                            onChange={(e) => setFieldValue('state', e.target.value)}
                            label="Estado"
                            inputProps={{
                                name: 'state',
                                id: 'outlined-age-native-simple',
                            }}
                            >
                            <option value={values.state}>{values.state}</option>
                            {
                                statesLocal.map((row) => <option value={row}>{row}</option> )
                            }
                            
                        </Select>
                    </FormControl>

                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSubmit} variant="contained" color="primary" disabled={values.name == "" || loading}>
                        {loading && <CircularProgress size={14} style={{ marginRight: 12 }} />}
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
